import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import * as moment from 'moment';

import { sanitizeServerUtcDate, MaxDate } from '@sd-portal/shared/util';
import { Leg } from './leg.model';
import { AutomatedOooiDataForm } from './automated-oooi-data-form.model';

export class LegOooiForm {
  outTime: FormControl = new FormControl('');
  offTime: FormControl = new FormControl('');
  onTime: FormControl = new FormControl('');
  inTime: FormControl = new FormControl('');
  automatedFlightData: FormGroup | null;

  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(leg?: Leg, includeControlValidation: boolean = false) {
    if (includeControlValidation) {
      const now = moment.utc();
      this.outTime.setValidators([Validators.required, MaxDate(now)]);
      this.offTime.setValidators([Validators.required, MaxDate(now)]);
      this.onTime.setValidators([Validators.required, MaxDate(now)]);
      this.inTime.setValidators([Validators.required, MaxDate(now)]);
    }

    if (leg) {
      const datesToSanitize = ['outTime', 'offTime', 'onTime', 'inTime'];

      datesToSanitize.forEach(dateToSanitize => {
        if (leg[dateToSanitize]) {
          this[dateToSanitize].setValue(sanitizeServerUtcDate(leg[dateToSanitize]));
        }
      });

      if (leg.automatedData && leg.automatedData.oooi) {
        this.automatedFlightData = new FormGroup(new AutomatedOooiDataForm(leg.automatedData.oooi));
      }
    }
  }
}

// functions
export function validateOooiTimes(
  minStart: moment.Moment | null | undefined,
  maxEnd: moment.Moment | null | undefined
): ValidatorFn {
  return (formGroup: FormGroup) => {
    const validationResponse: any = {}; // eslint-disable-line @typescript-eslint/no-explicit-any
    const outTimeControl = formGroup.get('outTime');
    const offTimeControl = formGroup.get('offTime');
    const onTimeControl = formGroup.get('onTime');
    const inTimeControl = formGroup.get('inTime');

    let outTime: moment.Moment;
    let offTime: moment.Moment;
    let onTime: moment.Moment;
    let inTime: moment.Moment;

    if (outTimeControl) {
      outTime = outTimeControl.value;
    }
    if (offTimeControl) {
      offTime = offTimeControl.value;
    }
    if (onTimeControl) {
      onTime = onTimeControl.value;
    }
    if (inTimeControl) {
      inTime = inTimeControl.value;
    }

    validateFlightTime();
    validateBlockTime();
    validateMinStart();
    validateMaxEnd();

    return Object.keys(validationResponse).length > 0 ? validationResponse : null;

    function validateFlightTime() {
      if (offTime && onTime) {
        const diff = onTime.diff(offTime);
        if (diff < 0) {
          validationResponse['invalidFlightTime'] = true;
        }
      }
    }
    function validateBlockTime() {
      if (outTime && inTime) {
        const diff = inTime.diff(outTime);
        if (diff < 0) {
          validationResponse['invalidBlockTime'] = true;
        }
      }
    }
    function validateMinStart() {
      const firstStart = outTime || offTime;
      if (firstStart && minStart && firstStart.diff(minStart) < 0) {
        //todo: this check should not be necessary if type information is correct... going to assume that it isn't
        validationResponse['startTimeIsBelowMinimum'] = true;
      }
    }
    function validateMaxEnd() {
      const lastEnd = inTime || onTime;
      if (lastEnd && maxEnd && lastEnd.diff(maxEnd) > 0) {
        validationResponse['endTimeIsAboveMaximum'] = true;
      }
    }
  };
}
